// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import AppContext from './contexts/AppContext';
import { useEffect, useState } from 'react';
import { Paper, Slide, Stack } from '@mui/material';
import { HomeInfoBanniereModal } from './sections/home';

// ----------------------------------------------------------------------

export default function App() {
  const [info, setInfo] = useState(false);

  useEffect(() => setTimeout(() => setInfo(true), [1000]), []);

  const googleTranslateElementInit = () => {
    window.google.translate.TranslateElement(
      {
        pageLanguage: 'fr',
        autoDisplay: false,
      },
      'google_translate_element'
    );
  };

  useEffect(() => {
    let addScript = document.createElement('script');
    addScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
  }, []);

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <AppContext>
              <ProgressBarStyle />
              <ChartStyle />
              <ScrollToTop />
              <Stack position="relative">
                {info && (
                  <Slide in direction="up">
                    <Stack
                      component={Paper}
                      elevation={12}
                      position="fixed"
                      bottom={24}
                      right={100}
                      left={{ xs: 16, sm: 'auto' }}
                      sx={{
                        width: { xs: 'auto', sm: 340 },
                        maxWidth: 380,
                        zIndex: (t) => t.zIndex.appBar + 100,
                        borderRadius: 2,
                        overflow: 'hidden',
                      }}
                    >
                      <HomeInfoBanniereModal onClose={() => setInfo(false)} />
                    </Stack>
                  </Slide>
                )}
                <Router />
              </Stack>
            </AppContext>
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
